import parseQueryStrings from "./parseQueryStrings/index.js";
function getNextUrl() {
    if ("u" < typeof window) return '';
    if (window.nextUrl) return window.nextUrl;
    const { next: nextUrl } = parseQueryStrings(window.location.search) || {};
    return 'string' == typeof nextUrl ? nextUrl : '';
}
const src_getNextUrl = getNextUrl;
export default src_getNextUrl;
export { getNextUrl };
